import script from "./ChannelAcc.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChannelAcc.vue?vue&type=script&setup=true&lang=ts"

import "./ChannelAcc.vue?vue&type=style&index=0&id=fff6b428&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fff6b428"]])

export default __exports__